import { render } from "./PortfolioView.vue?vue&type=template&id=68a79724&ts=true"
import script from "./PortfolioView.vue?vue&type=script&lang=ts"
export * from "./PortfolioView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__